import {z} from "zod"

export const dataObjectReferenceSchema = z.object({
    type: z.literal("dataObjectReference"),
    dataObjectId: z.number().or(z.string()),
})
export type DataObjectReference = z.infer<typeof dataObjectReferenceSchema>

export const collectDataObjectReferences = async (graph: unknown, visited: Set<unknown> = new Set<unknown>()): Promise<Set<number | string>> => {
    if (visited.has(graph)) {
        return new Set()
    }
    visited.add(graph)

    // don't use zod for this - it's too slow(!)
    if (
        graph !== null &&
        typeof graph === "object" &&
        "type" in graph &&
        graph.type === "dataObjectReference" &&
        "dataObjectId" in graph &&
        (typeof graph.dataObjectId === "number" || typeof graph.dataObjectId === "string")
    ) {
        return new Set([graph.dataObjectId])
    }

    const result = new Set<number | string>()
    for (const value of Object.values(graph ?? {})) {
        if (value) {
            for (const item of await collectDataObjectReferences(value, visited)) {
                result.add(item)
            }
        }
    }
    return result
}
